<script>
  export let title = ""
  export let width = undefined
</script>

<div class="card" style="width: {width}">
  <div class="card-title">
    {#if title}
      {title}
    {:else}
      <slot name="title" />
    {/if}
  </div>
  <div class="card-body">
    <slot />
  </div>
</div>

<style>
  .card {
    background-color: #fff;
    color: rgba(0, 0, 0, 0.87);
    border-radius: 4px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 1px 3px 0 rgba(0,0,0,0.12);
    overflow: hidden;
    min-width: 275px;
    padding: 16px;
    display: flex;
    flex-direction: column;
  }
  .card-title {
    font-size: 1.1rem;
    font-weight: bold;
  }
  .card-body {
    font-size: 1rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
</style>